export default __webpack_public_path__ + "static/assets/f25b05fd7194af8fed79dca01d520948.gif";